export const ADDON_ID = 'cssVariables';
export const CLEAR_LABEL = 'No Theme';
export const EVENT_NAME = 'storybookcssvariables:theme:change';
